var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40152 2.50065H3.59884C2.82387 1.45386 3.86795 -0.0111673 5.16489 0.407216L5.7834 0.606745C5.92423 0.652173 6.07613 0.652173 6.21695 0.606745L6.83546 0.407217C8.1324 -0.0111668 9.17648 1.45386 8.40152 2.50065ZM3.67095 3.50065H8.3294C9.20892 3.98764 9.89604 4.80074 10.2107 5.80755L11.044 8.47422C11.8489 11.0499 9.92464 13.6673 7.22608 13.6673H4.77427C2.07571 13.6673 0.15144 11.0499 0.956353 8.47422L1.78969 5.80755C2.10432 4.80073 2.79144 3.98764 3.67095 3.50065ZM8.24282 10.7712C8.48426 10.6371 8.57135 10.3328 8.43733 10.0913C8.30332 9.84989 7.99895 9.7628 7.75751 9.89681C6.97809 10.3294 6.44382 10.5007 5.96025 10.4988C5.47917 10.4968 4.97395 10.3231 4.25205 9.90207C4.01351 9.76295 3.70736 9.84356 3.56824 10.0821C3.42913 10.3206 3.50973 10.6268 3.74828 10.7659C4.5293 11.2214 5.21669 11.4958 5.95619 11.4988C6.69319 11.5018 7.40746 11.2348 8.24282 10.7712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.ad23a46a.svg";
export { ForwardRef as ReactComponent };